import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import PopupHeading from '@/shared/legacy/ui/popup-layout/heading.vue';
import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';
import aiImg from './assets/ai-big.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'modal-header',
  props: {
    showBack: { type: Boolean }
  },
  emits: ["back"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupHeading, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.container)
      }, [
        (__props.showBack)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style.back),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
            }, [
              _createVNode(BaseIcon, { type: "arrow-narrow-left-24" })
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          class: _normalizeClass(_ctx.$style.icon),
          alt: "ai",
          src: _unref(aiImg)
        }, null, 10, _hoisted_1),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.$style.text)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 2)
    ]),
    _: 3
  }))
}
}

})